/**
 * Abstract collision.
 *
 * @class AbstractCollision
 */
export default class AbstractCollision {
    /**
     * @constructor
     * @param {AbstractItem} item
     * @param {AbstractItem} otherItem
     */
    constructor(item, otherItem) {
        this.item = item;
        this.otherItem = otherItem;
    }
}
